import React, { useEffect, useState, useRef, useCallback, Fragment } from "react";
import {
  Container,
  UncontrolledTooltip,
  DropdownToggle,
  DropdownMenu,
  Dropdown,
  DropdownItem,
  Row,
  Col,
  Card,
  CardBody,
  Alert,
  Spinner,
} from "reactstrap";
import { Link } from "react-router-dom";
import SimpleBar from "simplebar-react";
import EmojiPicker from "emoji-picker-react";

//Import Icons
import FeatherIcon from "feather-icons-react";
import PersonalInfo from "./PersonalInfo";


import avatar from "../../assets/images/users/user-dummy-img.jpg";
//Import Scrollbar
import "react-perfect-scrollbar/dist/css/styles.css";


import ChatModal from "./ChatModal";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchLastChats, fetchMessagesByChat } from "api/queries/chat";
import {
  ChatDto,
  CreateChatMessageDtoTypeUserEnum,
} from "generated/apiChats";
import { deleteBulkChat } from "api/mutators/chat";
import { toast } from "react-toastify";
import DeleteModal from "./DeleteModal";
import { getLoggedinUser } from "helpers/api_helper";
import DocumentItem from "./DocumentItem";

//INIZIO --------------------------------------------

const Chat = () => {
  const userChatShow: any = useRef();
  const authUser: any = getLoggedinUser();

  const queryClient = useQueryClient();

  const [isInfoDetails, setIsInfoDetails] = useState<boolean>(false);
  const [Chat_Box_Username, setChat_Box_Username] =
    useState<any>("Agente AI Care");
  const [user_Status, setUser_Status] = useState<string | null>("online");
  const [chatModal, setChatModal] = useState<boolean>(false);
  const [chatId, setChatId] = useState<any>("");
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [streamingResponse, setStreamingResponse] = useState<string>("");

  const [Chat_Box_Image, setChat_Box_Image] = useState<any>(avatar);

  const [curMessage, setcurMessage] = useState<string>("");
  const [sendedMessage, setSendedMessage] = useState<string>("");
  const [messages, setMessages] = useState<any[]>([]);

  const [settings_Menu, setsettings_Menu] = useState<boolean>(false);
  const [reply, setreply] = useState<any>("");
  const [emojiPicker, setemojiPicker] = useState<boolean>(false);

  const endRef = useRef<HTMLDivElement | null>(null);

  const toggleChat = useCallback(() => {
    if (chatModal) {
      setChatModal(false);
    } else {
      setChatModal(true);
    }
  }, [chatModal]);


  const {
    isPending,
    data: agentChats,
    error,
    refetch,
  } = useQuery<any>({
    queryKey: fetchLastChats.queryKey([]),
    queryFn: () => fetchLastChats.queryFn(),
  });


  const {
    isPending: isPendingMessage,
    data: messageByChat,
    error: errorMessage,
    refetch: refetchMessagesByChat,
  } = useQuery<any>({
    queryKey: fetchMessagesByChat.queryKey([chatId]),
    queryFn: () => fetchMessagesByChat.queryFn(chatId),
    enabled: chatId !== "",
  });



  const deleteChatMutation = useMutation({
    mutationFn: deleteBulkChat,
    onError: (error: any) => {
      queryClient.invalidateQueries({
        queryKey: ["fetchMessagesByChat"],
      });

      queryClient.invalidateQueries({
        queryKey: ["fetchLastChats"],
      });
      toast.error("Error! Message not sended", { autoClose: 3000 });
    },
    onSuccess: () => {
      setChatId("");
      setChat_Box_Username("Agente AI Care");
      queryClient.invalidateQueries({
        queryKey: ["fetchMessagesByChat"],
      });
      queryClient.invalidateQueries({
        queryKey: ["fetchLastChats"],
      });
    },
  });

  
  useEffect(() => {
    // Scrolla sempre quando arriva un nuovo messaggio
      setMessages(messageByChat || []);
  }, [messageByChat]);

  const sendMessageWithStreaming = async (messageText: string, chatId: string) => {
    if (!chatId) return;
    try {
      setStreamingResponse(""); // reset

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/v1/chat/message/create`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${authUser.accessToken || ""}`,
          },
          body: JSON.stringify({
            chatId,
            text: messageText,
            typeUser: CreateChatMessageDtoTypeUserEnum.User,
            userId: authUser.uid || "", // <-- personalizza con l'ID utente reale
          }),
        }
      );

      const reader = response.body?.getReader();
      const decoder = new TextDecoder("utf-8");

      if (!reader) throw new Error("No response body");

      let resultText = "";
      let done = false;
      let receivedMeta = false;
      let metaBuffer = "";
      let resources: any[] = [];

      while (!done) {
        const { value, done: isDone } = await reader.read();
        done = isDone;

        if (value) {
          const chunk = decoder.decode(value, { stream: true });
          console.log("Received chunk:", chunk);

          const endMarker = "<END_OF_MESSAGE>";

          if (!receivedMeta && chunk.includes(endMarker)) {
            const [textPart, jsonPart] = chunk.split(endMarker);

            resultText += textPart;
            setStreamingResponse((prev) => prev + textPart);

            // Tentiamo di parsare il JSON finale
            try {
              const metaJson = JSON.parse(jsonPart.trim());
              console.log("Meta ricevuto:", metaJson);
            } catch (e) {
              console.warn("Errore parsing JSON post <END_OF_MESSAGE>:", jsonPart);
            }

            receivedMeta = true;
          } else if (!receivedMeta) {
            resultText += chunk;
            setStreamingResponse((prev) => prev + chunk);
          } else {
            metaBuffer += chunk;
          }
        }
      }

      // Caso in cui JSON era in chunk separato
      if (!receivedMeta && metaBuffer) {
        try {
          resources = JSON.parse(metaBuffer.trim()).retrieverResources || [];
          console.log("🧠 Meta ricevuto (da metaBuffer):", resources);
        } catch (e) {
          console.warn("Errore parsing JSON da metaBuffer:", metaBuffer);
        }
      }




      setMessages((prev) => [...prev, {
        text: resultText,
        typeUser: CreateChatMessageDtoTypeUserEnum.Chatbot,
        createdAt: new Date().toISOString(),
        resources: resources,
      }]);
      setSendedMessage("");
      setcurMessage("");
      setreply("");
      setStreamingResponse("");
      queryClient.invalidateQueries({
        queryKey: ["fetchMessagesByChat"],
      });
    
  
    } catch (err) {
      toast.error("Errore nel ricevere risposta dall'agente");
      console.error(err);
    }
  };

 

  const toggleSettings = () => {
    setsettings_Menu(!settings_Menu);
  };


  //Use For Chat Box
  const userChatOpen = (chats: any) => {
    setChat_Box_Username("Agente AI Care - " + chats.title);
    setChat_Box_Image(avatar);
    setUser_Status("online");
    setChatId(chats.id);

    // dispatch(onGetMessages(chats.roomId));
    if (window.innerWidth < 892) {
      userChatShow.current.classList.add("user-chat-show");
    }
    // remove unread msg on read in chat
    var unreadMessage: any = document.getElementById(
      "unread-msg-user" + chats.id
    );
    var msgUser: any = document.getElementById("msgUser" + chats.id);
    if (unreadMessage) {
      unreadMessage.style.display = "none";
    }
    if (msgUser) {
      msgUser.classList.remove("unread-msg-user");
    }
  };

  const backToUserChat = () => {
    userChatShow.current.classList.remove("user-chat-show");
  };

  // add message
  const addMessage = () => {
    if (chatId === "") {
      toast.error("Error! Nessuna Chat selezionata", { autoClose: 3000 });
      return;
    }

    const curMessageTrimmed = curMessage.trim();
    if (curMessageTrimmed !== "") {
      // chiama fetch streaming
      console.log("Sending message:", curMessageTrimmed);
      setSendedMessage(curMessageTrimmed);
      setMessages((prev) => [...prev, {
        text: curMessageTrimmed,
        typeUser: CreateChatMessageDtoTypeUserEnum.User,
        createdAt: new Date().toISOString(),
      }]);
      setcurMessage("");
      sendMessageWithStreaming(curMessage, chatId);
    }
  };

  const chatRef = useRef<any>(null);
  useEffect(() => {
    if (chatRef.current?.el) {
      chatRef.current.getScrollElement().scrollTop =
        chatRef.current.getScrollElement().scrollHeight;
    }
  }, [messages, streamingResponse]);

  const onKeyPress = (e: any) => {
    const { key, value } = e;
    if (key === "Enter") {
      e.preventDefault();
      setcurMessage(value);
      addMessage();
    }
  };

  // emoji
  const [emojiArray, setemojiArray] = useState<any>([]);
  const onEmojiClick = (event: any, emojiObject: any) => {
    setemojiArray([...emojiArray, event.emoji]);
    setcurMessage(curMessage + event.emoji);
  };

  document.title = "Chat | AICare";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="chat-wrapper d-lg-flex gap-1 mx-n4 mt-n4 p-1">
            <div className="chat-leftsidebar minimal-border">
              <div className="px-4 pt-4 mb-3">
                <div className="d-flex align-items-start">
                  <div className="flex-grow-1">
                    <h5 className="mb-4">Chats</h5>
                  </div>
                </div>
              </div>

              <div id="chats">
                {isPending ? (
                   <Spinner className='position-absolute top-50 start-50' animation='border' color="primary" />
                ) : (
                  <SimpleBar
                    className="chat-room-list pt-3"
                    style={{ margin: "-16px 0px 0px" }}
                  >
                    <div className="d-flex align-items-center px-4 mb-2">
                      <div className="flex-grow-1">
                        <h4 className="mb-0 fs-11 text-muted text-uppercase">
                          Last Chats
                        </h4>
                      </div>
                      <div className="flex-shrink-0">
                        <UncontrolledTooltip
                          placement="bottom"
                          target="newchat"
                        >
                          New Chat
                        </UncontrolledTooltip>
                        <button
                          type="button"
                          id="newchat"
                          className="btn btn-soft-success btn-sm material-shadow"
                          onClick={() => {
                            toggleChat();
                          }}
                        >
                          <i className="ri-add-line align-bottom"></i>
                        </button>
                      </div>
                    </div>

                    <div className="chat-message-list">
                      <ul
                        className="list-unstyled chat-list chat-user-list users-list"
                        id="userList"
                      >
                        {(agentChats || []).map((chat: ChatDto) => (
                          <li key={chat.id} className={ chat.id === chatId ? `${ "active"}`: ""}> 
                            <Link
                              to="#!"
                              onClick={() => userChatOpen(chat)}
                              id={"msgUser" + chat.id}
                            >
                              <div className="d-flex align-items-center">
                                <div
                                  className={`flex-shrink-0 chat-user-img online align-self-center me-2 ms-0`}
                                >
                                  <div className="avatar-xxs">
                                    <div
                                      className={
                                        "avatar-title rounded-circle bg-yellow userprofile"
                                      }
                                    >
                                      {chat.title.charAt(0)}
                                    </div>
                                  </div>
                                  <span className="user-status"></span>
                                </div>
                                <div className="flex-grow-1 overflow-hidden">
                                  <p className="text-truncate mb-0">
                                    {chat.title}
                                  </p>
                                </div>
                              </div>
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </SimpleBar>
                )}
              </div>
            </div>

            <div
              className="user-chat w-100 overflow-hidden minimal-border"
              ref={userChatShow}
            >
              <div className="chat-content d-lg-flex">
                <div className="w-100 overflow-hidden position-relative">
                  <div className="position-relative">
                    <div className="p-3 user-chat-topbar">
                      <Row className="align-items-center">
                        <Col sm={4} xs={8}>
                          <div className="d-flex align-items-center">
                            <div className="flex-shrink-0 d-block d-lg-none me-3">
                              <Link
                                to="#"
                                onClick={backToUserChat}
                                className="user-chat-remove fs-18 p-1"
                              >
                                <i className="ri-arrow-left-s-line align-bottom"></i>
                              </Link>
                            </div>
                            <div className="flex-grow-1 overflow-hidden">
                              <div className="d-flex align-items-center">
                                <div className="flex-shrink-0 chat-user-img online user-own-img align-self-center me-3 ms-0">
                                  {Chat_Box_Image === undefined ? (
                                    <img
                                      src={avatar}
                                      className="rounded-circle avatar-xs"
                                      alt=""
                                    />
                                  ) : (
                                    <img
                                      src={Chat_Box_Image}
                                      className="rounded-circle avatar-xs"
                                      alt=""
                                    />
                                  )}
                                  <span className="user-status"></span>
                                </div>
                                <div className="flex-grow-1 overflow-hidden">
                                  <h5 className="text-truncate mb-0 fs-16">
                                    <a
                                      className="text-reset username"
                                      data-bs-toggle="offcanvas"
                                      href="#userProfileCanvasExample"
                                      aria-controls="userProfileCanvasExample"
                                    >
                                      {Chat_Box_Username}
                                    </a>
                                  </h5>
                                  <p className="text-truncate text-muted fs-14 mb-0 userStatus">
                                    <small>
                                      {user_Status === null
                                        ? "24 Members"
                                        : user_Status}
                                    </small>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Col>
                        <Col sm={8} xs={4}>
                          <ul className="list-inline user-chat-nav text-end mb-0">
                            <li className="list-inline-item m-0">
                              <Dropdown
                                isOpen={settings_Menu}
                                toggle={toggleSettings}
                              >
                                <DropdownToggle
                                  className="btn btn-ghost-secondary btn-icon material-shadow-none"
                                  tag="button"
                                  style={ chatId === "" ? { display: "none" } : {} }
                                >
                                  <FeatherIcon
                                    icon="more-vertical"
                                    className="icon-sm"
                                  />
                                </DropdownToggle>
                                <DropdownMenu>
                                  <DropdownItem
                                    href="#"
                                    onClick={() => {
                                      setDeleteModal(true);
                                    }}
                                  >
                                    <i className="ri-delete-bin-5-line align-bottom text-muted me-2"></i>
                                    Delete
                                  </DropdownItem>
                                </DropdownMenu>
                              </Dropdown>
                            </li>
                          </ul>
                        </Col>
                      </Row>
                    </div>

                    <div className="position-relative" id="users-chat">
                      <div
                        className="chat-conversation p-3 p-lg-4 simplebar-scrollable-y"
                        id="chat-conversation"
                      >
                        {isPending && isPendingMessage ? (
                           <Spinner className='position-absolute top-50 start-50' animation='border' color="primary" />
                        ) : (
                          <SimpleBar ref={chatRef} style={{ height: "100%" }}>
                            <ul
                              className="list-unstyled chat-conversation-list"
                              id="users-conversation"
                            >
                              {!isPendingMessage &&
                                messages &&
                                messages?.map(
                                  (message: any, key: number) => (
                                    <li
                                      className={
                                        message.typeUser ===
                                        CreateChatMessageDtoTypeUserEnum.Chatbot
                                          ? "chat-list left"
                                          : "chat-list right"
                                      }
                                      key={key}
                                    >
                                      <div className="conversation-list">
                                        {message.sender === Chat_Box_Username &&
                                          message.typeUser ===
                                            CreateChatMessageDtoTypeUserEnum.User && (
                                            <div className="chat-avatar">
                                              {Chat_Box_Image === undefined ? (
                                                <img src={avatar} alt="" />
                                              ) : (
                                                <img src={avatar} alt="" />
                                              )}
                                            </div>
                                          )}
                                        <div className="user-chat-content">
                                          <div className="ctext-wrap">
                                            <>
                                              <div className="ctext-wrap-content">
                                                <p className="mb-0 ctext-content">
                                                    {message.text.split('\n').map((line: string, i: number) => (
                                                      <Fragment key={i}>
                                                        <span dangerouslySetInnerHTML={{ __html: line }} />
                                                        <br />
                                                      </Fragment>
                                                    ))}
                                                  </p>
                                                {Array.isArray(message.resources) && message.resources.length > 0 && (
                                                    <div className="mt-3">
                                                      <small className="text-muted d-block mb-2">Citazioni:</small>
                                                      <ul className="ps-3">
                                                        {message.resources.map((res: any, idx: number) => (
                                                          <DocumentItem key={idx} doc={res} />
                                                        ))}
                                                      </ul>
                                                    </div>
                                                  )}
                                              </div>
                                            </>
                                          </div>

                                          <div className="conversation-name">
                                            <small className="text-muted time">
                                              {message.createdAt
                                                ? new Date(
                                                    message.createdAt
                                                  ).toLocaleTimeString([], {
                                                    hour: "2-digit",
                                                    minute: "2-digit",
                                                  })
                                                : ""}
                                            </small>
                                            <span className="text-success check-message-icon">
                                              <i className="ri-check-double-line align-bottom"></i>
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </li>
                                  )
                                )}
                            {streamingResponse && (
                                <li className="chat-list left">
                                  <div className="conversation-list">
                                    <div className="user-chat-content">
                                      <div className="ctext-wrap">
                                        <div className="ctext-wrap-content">
                                          <p className="mb-0 ctext-content">
                                            {streamingResponse.split('\n').map((line: string, i: number) => (
                                              <Fragment key={i}>
                                                <span dangerouslySetInnerHTML={{ __html: line }} />
                                                <br />
                                              </Fragment>
                                            ))}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </li>
                              )}
                            </ul>
                            <div ref={endRef} />
                          </SimpleBar>
                        )}
                      </div>
                      {/* copy msg */}
                      <Alert
                        color="warning"
                        className="copyclipboard-alert px-4 fade"
                        id="copyClipBoard"
                        role="alert"
                      >
                        Message copied
                      </Alert>
                      {/* emoji picker */}
                      {emojiPicker && (
                        <EmojiPicker
                          onEmojiClick={onEmojiClick}
                          width={250}
                          height={382}
                        />
                      )}
                    </div>

                    <div className="chat-input-section p-3 p-lg-4">
                      <form id="chatinput-form">
                        <Row className="g-0 align-items-center">
                          <div className="col-auto">
                            <div className="chat-input-links me-2">
                              <div className="links-list-item">
                                <button
                                  type="button"
                                  className="btn btn-link text-decoration-none emoji-btn"
                                  id="emoji-btn"
                                  onClick={() => setemojiPicker(!emojiPicker)}
                                >
                                  <i className="bx bx-smile align-middle"></i>
                                </button>
                              </div>
                            </div>
                          </div>

                          <div className="col">
                            <div className="chat-input-feedback">
                              Please Enter a Message
                            </div>
                            <input
                              type="text"
                              value={curMessage}
                              onKeyDown={onKeyPress}
                              onChange={(e) => setcurMessage(e.target.value)}
                              className="form-control chat-input bg-light border-light"
                              id="chat-input"
                              placeholder={
                                    chatId === ""
                                        ? "Seleziona una chat o creane una nuova"
                                        : "Chiedi qualcosa all'Agente AI.."
                                }
                                disabled={chatId === ""} 
                            />
                          </div>
                          <div className="col-auto">
                            <div className="chat-input-links ms-2">
                              <div className="links-list-item">
                                <button
                                  type="button"
                                  disabled={curMessage === ""  || sendedMessage !== ""  || chatId === ""}
                                  onClick={() => {
                                    addMessage();
                                    setemojiPicker(false);
                                    setemojiArray("");
                                  }}
                                  className="btn btn-success chat-send waves-effect waves-light disable"
                                >
                                  <i className="ri-send-plane-2-fill align-bottom"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </Row>
                      </form>
                    </div>

                    <div className={reply ? "replyCard show" : "replyCard"}>
                      <Card className="mb-0">
                        <CardBody className="py-3">
                          <div className="replymessage-block mb-0 d-flex align-items-start">
                            <div className="flex-grow-1">
                              <h5 className="conversation-name">
                                {reply && reply.sender}
                              </h5>
                              <p className="mb-0">{reply && reply.msg}</p>
                            </div>
                            <div className="flex-shrink-0">
                              <button
                                type="button"
                                id="close_toggle"
                                className="btn btn-sm btn-link mt-n2 me-n3 fs-18"
                                onClick={() => setreply("")}
                              >
                                <i className="bx bx-x align-middle"></i>
                              </button>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </div>

      <PersonalInfo
        show={isInfoDetails}
        onCloseClick={() => setIsInfoDetails(false)}
        currentuser={Chat_Box_Username}
        cuurentiseImg={Chat_Box_Image}
      />
      <ChatModal
        modal={chatModal}
        toggle={toggleChat}
        setModal={setChatModal}
        refetchFiles={refetch}
        setChatId={setChatId}
        setBox={setChat_Box_Username}
      />
      <DeleteModal
        show={deleteModal}
        onDeleteClick={() => {
          deleteChatMutation.mutate({
            ids: [chatId],
          });
          setDeleteModal(false);
        }}
        onCloseClick={() => setDeleteModal(false)}
      />
    </React.Fragment>
  );
};

export default Chat;
